// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import csolEntity from './entities/csol.json';
import csolMenu from '../pages/csol/menu.json';
import csolFullForm from '../pages/csol/forms/full.json';
import csolContextForm from '../pages/csol/forms/context.json';
import csolMiniForm from '../pages/csol/forms/mini.json';
import csolLookupForm from '../pages/csol/forms/lookup.json';
import csolTableView from '../pages/csol/views/table.json';
import csolStagesView from '../pages/csol/views/stages.json';
import csolCardsView from '../pages/csol/views/cards.json';
import csolInlineView from '../pages/csol/views/inline.json';
import csolBacklogView from '../pages/csol/views/backlog.json';
import csolSplitView from '../pages/csol/views/split.json';
import csolCalendarView from '../pages/csol/views/calendar.json';
import csolDashboardView from '../pages/csol/views/dashboard.json';

/** Тип запису «Концепція рішення» зі сторінками пакета: меню, форми та подання з pages/csol/. */
export const csolDefinition: IRecordTypeDefinition = {
  ...csolEntity,
  views: assembleViewSet({
      table: csolTableView,
      stages: csolStagesView,
      cards: csolCardsView,
      inline: csolInlineView,
      backlog: csolBacklogView,
      split: csolSplitView,
      calendar: csolCalendarView,
      dashboard: csolDashboardView,
  }),
  form: csolFullForm,
  forms: { full: csolFullForm, context: csolContextForm, mini: csolMiniForm, lookup: csolLookupForm },
  menu: csolMenu,
} as IRecordTypeDefinition;
